/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseType } from '../../models/course-type';

export interface ApiMasterCourseTypeGetAllGet$Params {
}

export function apiMasterCourseTypeGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterCourseTypeGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CourseType>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCourseTypeGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CourseType>>;
    })
  );
}

apiMasterCourseTypeGetAllGet.PATH = '/api/Master/CourseType/GetAll';
